let globalState = null

export setGlobalState(st) ->
  now globalState = st

export getGlobalState() -> globalState
